import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';

// Styles & Images
import { NavigationButton, DatePicker, DateFilterWrapper } from './styles';

const renderArrow = (theme, direction) => <svg className={`arrow ${direction}`} width="16" height="16" viewBox="0 0 16 16">
  <g fill="none" fillRule="evenodd">
    <path d="M-4-4h24v24H-4z" />
    <path fill={theme.color.primary} fillRule="nonzero" d="M16 7H3.83l5.59-5.59L8 0 0 8l8 8 1.41-1.41L3.83 9H16z" />
  </g>
</svg>;


export default withTheme(translate()(props => {
  const { startDate, onDateChange, theme } = props;

  const handleClick = add => {
    if (add) {
      onDateChange(startDate.add(1, 'days'));
    } else {
      onDateChange(startDate.subtract(1, 'days'));
    }
  };

  const handleDateChange = date => {
    onDateChange(date);
  };

  return (
    <DateFilterWrapper>

      <NavigationButton onClick={() => { handleClick(); }}>
        {renderArrow(theme, 'left')}
      </NavigationButton>

      <DatePicker
        dateFormat="DD.MM.YYYY dd" // If long day need -> "DD.MM.YYYY dddd"
        selected={startDate}
        readOnly={true}
        onChange={handleDateChange}
      />

      <NavigationButton onClick={() => { handleClick(true); }}>
        {renderArrow(theme, 'right')}
      </NavigationButton>

    </DateFilterWrapper>
  );
}));
